import React, {
  useMemo, useState, createContext, useCallback,
} from 'react';


const RefreshingContext = createContext({
  isRefreshing: false,
  onRefresh: () => {},
});

export const RefreshingProvider = ({
  onRefresh,
  children,
}) => {
  const [isRefreshing, setRefreshing] = useState(false);

  const onRefreshFn = useCallback(() => {
    const fn = async () => {
      setRefreshing(true);
      try {
        await onRefresh();
      } finally {
        setRefreshing(false);
      }
    };
    fn();
  }, [onRefresh]);

  return useMemo(() => (
    <RefreshingContext.Provider value={{
      isRefreshing,
      setRefreshing,
      onRefresh: onRefreshFn,
    }}
    >
      { children }
    </RefreshingContext.Provider>
  ), [children, isRefreshing, onRefreshFn]);
};

export default RefreshingContext;
